export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M0 2a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2zm15 2h-4v3h4V4zm0 4h-4v3h4V8zm0 4h-4v3h3a1 1 0 001-1v-2zm-5 3v-3H6v3h4zm-5 0v-3H1v2a1 1 0 001 1h3zm-4-4h4V8H1v3zm0-4h4V4H1v3zm5-3v3h4V4H6zm4 4H6v3h4V8z\"/>",
  "attrs": {
    "width": "1em",
    "height": "1em",
    "viewBox": "0 0 16 16",
    "class": "bi bi-table",
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};